import i18n from "../../src/lang/index.js";
// 111007686
// 初始数据
export let medical = {
  language: getUal(getUrl().language || "zh"),
  userId: getUrl().userId || "488277965969428481",
  // 488277965969428481 // my
  phone: getUrl().phone || "",
  imei: getUrl().imei || "",
  cpid: getUrl().cpid || "390703042925826050",
  // 小白手表
  type: getUrl().type || "app", // 区分app还是微信小程序
  mac: getUrl().mac || "",
  model: getUrl().model || "", // 手机型号
  // 缓存
  indexTag: true, // 主页
  detailsTag: true, // 成员页
  addMemberTag: true // 加入的群组
};

// 获取url参数
export function getUrl() {
  var url = window.location.href;
  var obj = {};
  var reg = /\?/;
  if (url.match(reg)) {
    var chars = url.split("?")[1];
    var arr = chars.split("&");
    for (var i = 0; i < arr.length; i++) {
      var num = arr[i].indexOf("=");
      if (num > 0) {
        var name = arr[i].substring(0, num);
        var value = arr[i].substr(num + 1);
        obj[decodeURIComponent(name)] = decodeURIComponent(value);
      }
    }
  }
  return obj;
}

// 判断是否中英文
export function getUal(ual) {
  if (ual.indexOf("zh") != -1) return "zh";
  if (ual.indexOf("en") != -1) return "en";
  if (ual.indexOf("fi") != -1) return "fi";
  if (ual.indexOf("ja") != -1) return "ja";
  if (ual.indexOf("ko") != -1) return "ko";
  if (ual.indexOf("th") != -1) return "th";
}

// 判断是否微信
export function checkIsWx() {
  if (navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1) {
    return true;
  } else {
    return false;
  }
}

// 判断是否Android
export function checkIsAndroid() {
  var browser = {
    versions: (function() {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      return {
        // 移动终端浏览器版本信息
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, // android终端或uc浏览器
        iPhone: u.indexOf("iPhone") > -1, // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1 // 是否iPad
      };
    })()
  };
  //if (browser.versions.iPhone || browser.versions.iPad || browser.versions.ios) {
  //    return false;
  //}
  if (browser.versions.android) return true;
  return false;
}

// 判断是否IOS
export function checkIsIOS() {
  var browser = {
    versions: (function() {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      return {
        // 移动终端浏览器版本信息
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, // android终端或uc浏览器
        iPhone: u.indexOf("iPhone") > -1, // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1 // 是否iPad
      };
    })()
  };
  if (
    browser.versions.iPhone ||
    browser.versions.iPad ||
    browser.versions.ios
  )  return true;
  else  return false;

}

// 获取当前可视范围的高度
export function getClientHeight() {
  var clientHeight = 0;
  if (document.body.clientHeight && document.documentElement.clientHeight) {
    clientHeight = Math.min(
      document.body.clientHeight,
      document.documentElement.clientHeight
    );
  } else {
    clientHeight = Math.max(
      document.body.clientHeight,
      document.documentElement.clientHeight
    );
  }
  return clientHeight;
}

// 获取文档完整的高度
export function getScrollHeight() {
  return Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight
  );
}
// 截取某个字符前、后的数据
export function getCaption(value, state) {
  var obj = value.toString();
  var index = obj.lastIndexOf(".");
  // console.log(index);
  if (state === 0) {
    obj = obj.substring(0, index);
  } else if (state === 1) {
    obj = obj.substring(index + 1, obj.length);
  }
  return obj;
}
// 睡眠
export function getSleeps(value) {
  var hover = Math.floor(value / 60);
  var minute = value - hover * 60;
  return [hover, minute];
}
// 查询元素在数组中的索引值
export function arrIndex(list, value) {
  for (var i = 0; i < list.length; i++) {
    if (list[i] == value) {
      return i;
    }
  }
}
// 补全0
export function zero(i) {
  return i >= 10 ? i : "0" + i;
}
// 当前
export function cuDateTime() {
  const date = new Date();
  return [
    date.getFullYear(),
    zero(date.getMonth() + 1),
    zero(date.getDate()),
    "00",
    "00"
  ];
}
export function getList(list) {
  return (
    list[0] + "-" + list[1] + "-" + list[2] + " " + list[3] + ":" + list[4]
  );
}
export function getList1(list) {
  return (
    list[0] +
    "/" +
    parseInt(list[1]) +
    "/" +
    parseInt(list[2]) +
    " " +
    parseInt(list[3]) +
    ":" +
    parseInt(list[4])
  );
}
export function isSportType1(name) {
  return name == "跑步" ? "running" : name == "骑行" ? "cycling" : "walking";
}
export function isSportType2(name) {
  return name == "running" ? "跑步" : name == "cycling" ? "骑行" : "徒步";
}

export function isGroupTag1(name) {
  if (name == "学校教室") {
    return "school";
  }
  if (name == "医院病房") {
    return "hospital";
  }
  if (name == "家庭") {
    return "family";
  }
  if (name == "公司") {
    return "company";
  }
  if (name == "好友") {
    return "friend";
  }
}
export function isGroupTag2(name) {
  if (name == "school") {
    return "学校教室";
  }
  if (name == "hospital") {
    return "医院病房";
  }
  if (name == "family") {
    return "家庭";
  }
  if (name == "company") {
    return "公司";
  }
  if (name == "friend") {
    return "好友";
  }
}

export function JCRING_isGroupTag1(name) {
  console.log(name, 65555);
  if (
    name == "学校群组" ||
    name == "学校グループ" ||
    name == "Kouluryhmä" ||
    name == "school group" ||
    name == "School Group" ||
    name == "school" ||
    name == "กลุ่มเพื่อนเรียน"
  ){return "school";}
  if (
    name == "医疗群组" ||
    name == "医療グループ" ||
    name == "Sairaalaryhmä" ||
    name == "hospital group" ||
    name == "Hospital Group" ||
    name == "hospital" ||
    name == "กลุ่มโรงพยาบาล"
  ){ return "hospital";}
  if (
    name == "家庭群组" ||
    name == "家庭" ||
    name == "家族グループ" ||
    name == "Perheryhmä" ||
    name == "family group" ||
    name == "Family Group" ||
    name == "family" ||
    name == "กลุ่มครอบครัว"
  ){return "family";}
  if (
    name == "公司群组" ||
    name == "公司" ||
    name == "会社のグループ" ||
    name == "Yritysryhmä" ||
    name == "company group" ||
    name == "Company Group" ||
    name == "company" ||
    name == "กลุ่มเพื่อนร่วมงาน"
  ){return "company";
  }
  if (
    name == "其他群组" ||
    name == "其他" ||
    name == "その他のグループ" ||
    name == "Muu ryhmä" ||
    name == "other group" ||
    name == "Other Group" ||
    name == "other" ||
    name == "กลุ่มอื่นๆ"
  ){
    return "friend";}
}
export function JCRING_isGroupTag2(e) {
  let name = e.toLowerCase();
  console.log(name, medical.language);
  if (medical.language == "zh") {
    if (name == "school" || name == "学校群组") return "学校群组";
    if (name == "hospital" || name == "医疗群组") return "医疗群组";
    if (name == "family" || name == "家庭群组") return "家庭群组";
    if (name == "company" || name == "公司群组") return "公司群组";
    if (name == "friend" || name == "其他群组") return "其他群组";
  } else if (medical.language == "ja") {
    if (name == "school") return "学校グループ";
    if (name == "hospital") return "医療グループ";
    if (name == "family") return "家族グループ";
    if (name == "company") return "会社のグループ";
    if (name == "friend") return "その他のグループ";
  } else if (medical.language == "fi") {
    if (name == "school") return "Kouluryhmä";
    if (name == "hospital") return "Sairaalaryhmä";
    if (name == "family") return "Perheryhmä";
    if (name == "company") return "Yritysryhmä";
    if (name == "friend") return "Muu ryhmä";
  } else if (medical.language == "en") {
    if (name == "school") return "school";
    if (name == "hospital") return "hospital";
    if (name == "family") return "family";
    if (name == "company") return "company";
    if (name == "friend") return "friend";
    if (name == "other") return "friend";
  } else if (medical.language == "th") {
    if (name == "school") return "กลุ่มเพื่อนเรียน";
    if (name == "hospital") return "กลุ่มโรงพยาบาล";
    if (name == "family") return "กลุ่มครอบครัว";
    if (name == "company") return "กลุ่มเพื่อนร่วมงาน";
    if (name == "friend") return "กลุ่มอื่นๆ";
    if (name == "other") return "กลุ่มอื่นๆ";
  }
}
export function getGroupTag(groupTag) {
  if (medical.language == "zh") {
    return isGroupTag2(groupTag);
  } else {
    return groupTag.toLowerCase().replace(/( |^)[a-z]/g, L => L.toUpperCase());
  }
}
// 返回顶部
export function scrollTopMethod(top) {
  document.documentElement.scrollTop = top;
  document.body.scrollTop = top;
  // window.pageYOffset = top;
}
// 时间比较
export function is(start, end, signup) {
  var curr = Math.round(new Date() / 1000);
  start = Math.round(new Date(getList1(start)) / 1000);
  end = Math.round(new Date(getList1(end)) / 1000);
  signup = Math.round(new Date(getList1(signup)) / 1000);
  // console.log(start + "--" + end + "--" + signup);
  // 1、开始时间小于结束时间并且小于报名截止时间
  // 2、结束时间大于报名截止时间并且大于当前时间
  // && end > Date.parse().getTime()
  if (start < end && start < signup && end > signup && end > curr) {
    return 1;
  } else {
    return 2;
  }
}
// 时间比较
export function isDate(start, end) {
  // console.log(formatDate(start)+"----"+end);
  start = Math.round(new Date(formatDate(start)) / 1000);
  end = Math.round(new Date(end) / 1000);
  // console.log(start + "--" + end);
  // 1、start(日期) 小于 end(入群日期)
  if (start < end) {
    return 1;
  } else {
    return 2;
  }
}
// 格式化日期：yyyy-MM-dd
export function formatDate(date) {
  return (
    date.getFullYear() +
    "-" +
    zero(date.getMonth() + 1) +
    "-" +
    zero(date.getDate())
  );
}
// 格式化日期：yyyy-MM-dd
export function formatDateZH(date) {
  date = new Date(date);
  return (
    date.getFullYear() +
    "年" +
    zero(date.getMonth() + 1) +
    "月" +
    zero(date.getDate()) +
    "日"
  );
}
// 格式化日期：yyyy-MM-dd
export function formatDate1(year, month, day) {
  month < 10 && (month = "0" + month);
  day < 10 && (day = "0" + day);
  var data = year + "-" + month + "-" + day;
  return data;
}

// 获取当前时间 yyyy-MM-dd hh:mm:ss
export function currDateTime() {
  var date = new Date();
  return (
    date.getFullYear() +
    "-" +
    zero(date.getMonth() + 1) +
    "-" +
    zero(date.getDate()) +
    " " +
    zero(date.getHours()) +
    ":" +
    zero(date.getMinutes()) +
    ":" +
    zero(date.getSeconds())
  );
}
// 设置上下限
export function getLimit(index1, index2, items) {
  var list = [];
  var item = [];
  for (var i = index1; i <= index2; i++) {
    list.push(i);
  }
  for (var i = 0; i < list.length; i++) {
    if (list[i] === items) {
      item.push(i);
    }
  }
  return {
    list,
    item
  };
}
// 小数设置上下限
export function getLimits(index1, index2, items) {
  var list = [];
  var item = [];
  var num2 = index1.toString().split(".")[1];
  var num4 = index2.toString().split(".")[1];
  if (num2.length === 2 && num4.length === 2) {
    for (var i = index1 * 100; i <= index2 * 100; i++) {
      list.push(i / 100);
    }
  } else if (num2.length === 1 && num4.length === 1) {
    for (var i = index1 * 10; i <= index2 * 10; i++) {
      if (
        (i / 10).toString().length === 1 ||
        (i / 10).toString().length === 2 ||
        (i / 10).toString().length === 3
      ) {
        list.push(i / 10 + ".0");
      } else {
        list.push(i / 10);
      }
    }
  }
  for (var i = 0; i < list.length; i++) {
    if (list[i] === items) {
      item.push(i);
    }
  }
  return {
    list,
    item
  };
}
// 小数设置上下限
export function getLimitb(index1, index2, items) {
  var list = [];
  var item = [];
  var num2 = index1.toString().split(".")[1];
  var num4 = index2.toString().split(".")[1];
  if (num2.length === 2 && num4.length === 2) {
    for (var i = index1 * 100; i <= index2 * 100; i++) {
      list.push(i / 100);
    }
  } else if (num2.length === 1 && num4.length === 1) {
    for (var i = index1 * 10; i <= index2 * 10; i++) {
      if (
        (i / 10).toString().length === 1 ||
        (i / 10).toString().length === 2 ||
        (i / 10).toString().length === 3
      ) {
        list.push(i / 10 + ".0");
      } else {
        list.push(i / 10);
      }
    }
  }
  for (var i = 0; i < list.length; i++) {
    if (list[i] === items) {
      item.push(i + 1);
    }
  }
  return {
    list,
    item
  };
}
// 得出周几
export function getweekday(date) {
  var weekArray = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
  var week = weekArray[new Date(date).getDay()]; //注意此处必须是先new一个Date
  return week;
}
// 得出周几英文
export function getweekdays(date) {
  var weekArray = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  var week = weekArray[new Date(date).getDay()]; //注意此处必须是先new一个Date
  return week;
}
// 格式化日期为英文
export function formatDateEn(value, type) {
  // 判断当前系统语言是否为英文
  if (medical.language == "zh") {
    // 中文
    return value;
  } else if (medical.language == "en" && value != undefined && value != "") {
    // 英文
    if (type == "date") {
      var year = value.match(/(\S*)年/)[1];
      var month = i18n.t("machine.record23")[
        parseInt(value.match(/年(\S*)月/)[1]) - 1
      ];
      var day = value.match(/月(\S*)日/)[1];
      if (value.indexOf(":") != -1) {
        return month + " " + day + ", " + year + " " + value.substr(-8);
      } else {
        return month + " " + day + ", " + year;
      }
    }
    if (type == "month") {
      var year = value.match(/(\S*)年/)[1];
      var month = i18n.t("machine.record23")[
        parseInt(value.match(/年(\S*)月/)[1]) - 1
      ];
      return month + " " + year;
    }
    if (type == "monthItem") {
      return i18n.t("machine.record23")[
        parseInt(value.match(/(\S*)月/)[1]) - 1
      ];
    }
    if (type == "year") {
      return value.match(/(\S*)年/)[1];
    }
  }else{
    var year = value.match(/(\S*)年/)[1];
    var month = i18n.t("machine.record23")[
      parseInt(value.match(/年(\S*)月/)[1]) - 1
    ];
    var day = value.match(/月(\S*)日/)[1];
    return month + " " + day + ", " + year;
  }
}

// 把-转换成年月日
export function getyears(value) {
  return (
    value.substr(0, 4) +
    "年" +
    value.substr(5, 2) +
    "月" +
    value.substr(8, 2) +
    "日"
  );
}



//////////////////
// WEBPACK FOOTER
// ./static/js/default.js
// module id = null
// module chunks = 